import * as actionTypes from '../actions/actionTypes';

const initialState = {
    academicDepartments: [],
    loadingAcademicDepartments: false,
    departmentAnnouncements: [],
    loadingDepartmentAnnouncements: false,
    loadingDepartmentSchedule: false
};

const loadAcademicDepartments = (state) => {
    return {
        ...state,
        loadingAcademicDepartments: true
    }
}

const setAcademicDepartments = ( state, action ) => {
    let tmp = [...action.academicDepartments]
    return {
        ...state,
        academicDepartments: tmp,
        loadingAcademicDepartments: false
    }
}

const loadDepartmentAnnouncements = (state) => {
    return {
        ...state,
        loadingDepartmentAnnouncements: true
    }
}

const setDepartmentAnnouncements = ( state, action ) => {
    let tmp = [...action.departmentAnnouncements]
    return {
        ...state,
        departmentAnnouncements: tmp,
        loadingDepartmentAnnouncements: false
    }
}

const loadDepartmentSchedule = (state) => {
    return {
        ...state,
        loadingDepartmentSchedule: true
    }
}

const saveDepartmentSchedule = (state) => {
    return {
        ...state,
        loadingDepartmentSchedule: false
    }
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_ACADEMIC_DEPARTMENTS: return loadAcademicDepartments( state );
        case actionTypes.SET_ACADEMIC_DEPARTMENTS: return setAcademicDepartments( state, action );
        case actionTypes.LOAD_DEPARTMENT_ANNOUNCEMENTS: return loadDepartmentAnnouncements( state );
        case actionTypes.SET_DEPARTMENT_ANNOUNCEMENTS: return setDepartmentAnnouncements( state, action );
        case actionTypes.LOAD_DEPARTMENT_SCHEDULE: return loadDepartmentSchedule( state );
        case actionTypes.SAVE_DEPARTMENT_SCHEDULE: return saveDepartmentSchedule( state );
        default: return state;
    }
};
export default reducer;